import styled, { css } from 'styled-components';

import { transition } from 'ggApp/utils/mixins/transition';
import { elevation } from 'ggApp/utils/mixins/elevation';

import NavigationLink from 'ggApp/shared/common/NavigationLink';

import { ForYouOutlineIcon, ForYouFilledIcon } from 'ggApp/shared/icons/BaseLayout/ForYou';
import { YourTechOutlineIcon, YourTechFilledIcon } from 'ggApp/shared/icons/BaseLayout/YourTech';
import AccountOutlineIcon from 'ggApp/shared/icons/BaseLayout/Account';

const buttonStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 48px;
    padding: 0 16px;
    margin-left: 16px;
    cursor: pointer;
    > * {
        cursor: pointer;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            &:hover > * {
                opacity: 1;
            }
        `}
`;

const iconStyles = css`
    height: 24px;
    width: 24px;
    margin-right: 8px;
    background-repeat: no-repeat;
    background-position: center;
    ${transition('all', 'medium-mobile', 'standard')};
`;

const ForYouOutline = styled(ForYouOutlineIcon)`
    ${iconStyles}
`;

const ForYouActive = styled(ForYouFilledIcon)`
    ${iconStyles}
`;

const YourTechOutline = styled(YourTechOutlineIcon)`
    ${iconStyles}
`;

const YourTechActive = styled(YourTechFilledIcon)`
    ${iconStyles}
`;

const AccountOutline = styled(AccountOutlineIcon)`
    ${iconStyles}
`;

const ForYouButton = styled(NavigationLink)`
    ${buttonStyles}
    &:hover > * {
        opacity: 0.5;
    }
    &:active > * {
        opacity: 1;
        transition: none;
    }
`;

const YourTechButton = styled(NavigationLink)`
    ${buttonStyles}
    &:hover > * {
        opacity: 0.5;
    }
    &:active > * {
        opacity: 1;
        transition: none;
    }
`;

const WishlistButton = styled(NavigationLink)`
    ${buttonStyles}
    &:hover > * {
        opacity: 0.5;
    }
    &:active > * {
        opacity: 1;
        transition: none;
    }
`;

const AccountButton = styled.div`
    ${buttonStyles};
    position: relative;
    &:after {
        visibility: hidden;
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 10px;
        bottom: -9px;
    }
    &:hover {
        &:after {
            visibility: visible;
        }
    }
`;

const ButtonTitle = styled.label`
    ${({ theme }) => css(theme.typography.SmallCapsHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    white-space: pre;
    ${transition('all', 'medium-desktop', 'standard')};
`;

const AccountMenuContainer = styled.div`
    min-width: 410px;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    top: 56px;
    z-index: 4;
    border-radius: 8px;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transform: scale(0.9);
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
    background-color: ${(props) => props.theme.colors.Background};
    ${AccountButton}:hover & {
        visibility: visible;
        opacity: 1;
        transform: scale(1);
        transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
    }
    ${elevation(3, false)};
`;

const Wrap = styled.div`
    display: flex;
    align-items: center;

    ${ButtonTitle} {
        ${({ theme, isTransparent }) => isTransparent && `color: ${theme.colors.Background};`};
    }
`;

export {
    Wrap,
    ForYouButton,
    WishlistButton,
    AccountButton,
    YourTechButton,
    ButtonTitle,
    AccountMenuContainer,
    ForYouOutline,
    ForYouActive,
    YourTechOutline,
    YourTechActive,
    AccountOutline,
};
